module.exports = __webpack_public_path__ + "static/10-9342483458b4a1dde44ce5b821d82910.jpg";